/*
 * @Author: chenchen
 * @Date: 2021-04-08 11:32:03
 * @LastEditTime: 2021-06-22 15:21:13
 * @LastEditors: chenchen
 * @Description: api request
 */

import req from "./request";
import ApiModule from "api-module";
const apiInstance = new ApiModule(req.axios, req.baseConfig);

// 自动导入module中接口模块(通过webpack的require.context)
const ctx = require.context("./module", true, /[a-z]+\.js$/);
const moduleConfigs = ctx.keys().map((path) => {
  const fixedPath = path.slice(2);
  const relativePath = `./module/${fixedPath}`;
  let name = fixedPath.split(".js")[0];
  name = name[0].toUpperCase() + name.substr(1);
  const resource = require("./module/" + fixedPath).default;
  const apiList = Object.keys(resource);
  return {
    relativePath,
    name,
    resource,
    apiList
  };
});

moduleConfigs.forEach((config) => {
  apiInstance.registerModule({
    name: config.name,
    module: config.resource
  });
});

export default apiInstance.request;
